import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
//import { AdminLayoutModule } from './layouts/admin-layout/admin-layout.module';

const defaultRoute = 'dashboard';

const routes: Routes = [
    {
      path: '',
      redirectTo: defaultRoute,
      pathMatch: 'full',
    }, {
      path: '',
      component: AdminLayoutComponent,
      children: [
          {
        path: '',
        loadChildren : () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule)
    }]},
    {
      path: '**',
      redirectTo: defaultRoute
    }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
